import { useContext, useEffect, useRef, useState } from "react";
import "./styles.css";
import api from "../../../../services/axiosConfig";
import ModalNovoUsuario from "./components/ModalNovousuario";
import { toast } from "react-toastify";
import { FaUserPlus } from "react-icons/fa6";
import { Context } from "../../../../hooks/useAuthContext";
import {
  Button,
  Col,
  FormGroup,
  Input,
  Label,
  Pagination,
  PaginationItem,
  PaginationLink,
  Row,
  Table,
} from "reactstrap";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import { FaEye, FaFileAlt, FaEyeSlash, FaGlobe } from "react-icons/fa";
import ModalDocumentos from "../../../../components/ModalDocumentos/ModalDocumentos";
import { formatPhone } from "../../../../utils/telefoneFormatter";
import { formatCpfCnpj } from "../../../../utils/cpfCnpjFormatter";
import { BsFileEarmarkExcelFill } from "react-icons/bs";
import { FiLock, FiSearch } from "react-icons/fi";
import ModalMotivos from "../../../../components/ModalMotivos/ModalMotivos";
import ModalNovoAfiliado from "./components/ModalNovoAfiliado";
import Swal from "sweetalert2";
import ModalListaDeRedes from "./components/ModalListaDeRedes/ModalListaDeRedes";

function Usuarios() {
  const { exibirLogs, userData } = useContext(Context);
  const [status, setStatus] = useState("");
  const [listaUsuarios, setListaUsuarios] = useState([]);
  const [originalListaUsuarios, setOriginalListaUsuarios] = useState([]);
  const [modalAberto, setModalAberto] = useState(false);
  const [modalAbertoAfiliado, setModalAbertoAfiliado] = useState(false);
  const [modalRedesAberto, setModalRedesAberto] = useState(false);
  const [redesSelecionadas, setRedesSelecionadas] = useState([]);
  const [usuarioParaRedes, setUsuarioParaRedes] = useState(null);

  const [search, setSearch] = useState("");
  const [tipoConta, setTipoConta] = useState("");
  const [statusAprovacao, setStatusAprovacao] = useState("");
  const [page, setPage] = useState(1);
  const [limit] = useState(10);
  const [totalPages, setTotalPages] = useState(1);
  const [sortField, setSortField] = useState("nome");
  const [sortOrder, setSortOrder] = useState("asc");
  const [totalDocs, setTotalDocs] = useState(1);

  const [showDocsModal, setShowDocsModal] = useState(false);
  const [docFrente, setDocFrente] = useState("");
  const [docVerso, setDocVerso] = useState("");
  const [nome, setNome] = useState("");
  const [cpfCnpj, setCpfCnpj] = useState("");

  const [usuarioSelecionado, setUsuarioSelecionado] = useState(null);

  const [showMotivoModal, setShowMotivoModal] = useState(false);
  const [uidParaReprovar, setUidParaReprovar] = useState(null);
  const [financeiroReadonly, setFinanceiroReadonly] = useState(false);
  const [filterIncompleteTerms, setFilterIncompleteTerms] = useState(false);

  const isInitialLoad = useRef(true);

  async function fetchDadosUsuarios() {
    try {
      const params = {
        status: status || undefined,
        tipoConta: tipoConta || undefined,
        statusAprovacao: statusAprovacao || undefined,
        search: search || undefined,
        page,
        limit,
        sortField,
        sortOrder,
        acceptedTerm: filterIncompleteTerms ? !filterIncompleteTerms : "",
        logAction: !isInitialLoad.current ? true : undefined,
      };

      const response = await api.get("/admin/users", { params });
      const users = response.data?.data || [];

      setListaUsuarios(users);
      setOriginalListaUsuarios(users);
      setTotalPages(response.data?.totalPages || 1);
      setTotalDocs(response.data?.total);
    } catch (error) {
      exibirLogs && console.error("Erro ao buscar usuários:", error);
    }
  }

  useEffect(() => {
    if (!isInitialLoad.current) {
      fetchDadosUsuarios();
    }
  }, [status, tipoConta, statusAprovacao, page, sortField, sortOrder, filterIncompleteTerms]);

   useEffect(() => {
    if (search === "") {
      fetchDadosUsuarios();
    }
    
    if (isInitialLoad.current) {
      isInitialLoad.current = false;
    }
  }, [search]); 

  async function activateUser(uid) {
    const result = await Swal.fire({
      title: "Deseja ativar este usuario?",
      text: "Ele voltará a ter acesso ao sistema.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sim, ativar!",
      cancelButtonText: "Cancelar",
    });

    if(result.isConfirmed){
      try {
        await api.put(`/admin/users/activate/${uid}`);
        toast.success("Usuário ativado!");
        await fetchDadosUsuarios();
        return;
      } catch (error) {
        exibirLogs && console.error("Erro ao ativar usuário:", error);
        toast.error("Erro ao ativar usuário!");
      }
    }
  }

  async function deactivateUser(uid, motivo) {
    try {
      await api.put(`/admin/users/deactivate/${uid}`, { motivo });
      toast.success("Usuário desativado!");
      await fetchDadosUsuarios();
    } catch (error) {
      exibirLogs && console.error("Erro ao desativar usuário:", error);
      toast.error("Erro ao desativar usuário!");
    }
  }

  async function exportarUsuariosUtm() {
    try {
      const params = {
        status: status || undefined,
        tipoConta: tipoConta || undefined,
        statusAprovacao: statusAprovacao || undefined,
        search: search || undefined,
        acceptedTerm: filterIncompleteTerms ? 'false' : undefined,
      };

      const response = await api.get("/auth/export-users-utm", {
        params,
        responseType: "blob",
      });

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "usuarios-utms.xlsx");
      document.body.appendChild(link);
      link.click();
      link.remove();
      toast.success("Planilha exportada com sucesso!");
    } catch (error) {
      exibirLogs && console.error("Erro ao exportar usuários:", error);
      toast.error("Erro ao exportar usuários!");
    }
  }

  const handleOpenDocs = (frente, verso, nome, cpfCnpj) => {
    setDocFrente(frente);
    setDocVerso(verso);
    setNome(nome);
    setCpfCnpj(cpfCnpj);
    setShowDocsModal(true);
  };

  const handleAbrirModalRedes = (usuario) => {
    setRedesSelecionadas(usuario.redesSociais);
    setUsuarioParaRedes(usuario);
    setModalRedesAberto(true);
  };

  const handleSalvarRedes = async (novasRedes) => {
    if (!usuarioParaRedes) {
      toast.error("Nenhum usuário selecionado para atualizar as redes.");
      return;
    }

    const dadosAtualizados = {
      redesSociais: novasRedes,
    };

    try {
      await api.put(`/auth/user/update/${usuarioParaRedes.uid}`, dadosAtualizados);
      toast.success("Redes sociais atualizadas com sucesso!");
      setModalRedesAberto(false);
      await fetchDadosUsuarios();
    } catch (error) {
      exibirLogs && console.error("Erro ao atualizar redes sociais:", error);
      toast.error(error.response?.data?.error || "Erro ao atualizar redes sociais.");
    }
  };

  return (
    <div className="usuariosContainer">
      <div className="usuariosHeader">
        <h3>Todos os usuários</h3>
      </div>

      <Row className="mb-3">
        <Col md={2} sm={12} xs={12}>
          <FormGroup>
            <Label>Status</Label>
            <Input
              type="select"
              value={status}
              onChange={(e) => {
                setPage(1);
                setStatus(e.target.value);
              }}
            >
              <option value="">Todos</option>
              <option value="ativo">Ativo</option>
              <option value="inativo">Inativo</option>
            </Input>
          </FormGroup>
        </Col>
        <Col md={2} sm={12} xs={12}>
          <FormGroup>
            <Label>Tipo de Conta</Label>
            <Input
              type="select"
              value={tipoConta}
              onChange={(e) => {
                setPage(1);
                setTipoConta(e.target.value);
              }}
            >
              <option value="">Todos</option>
              <option value="usuario">Cortador</option>
              <option value="administrador">Administrador</option>
              <option value="automacao">Automação</option>
              <option value="gestor">Gestor</option>
              <option value="influenciador">Influenciador</option>
              <option value="afiliado">Afiliado</option>
            </Input>
          </FormGroup>
        </Col>
        <Col md={2} sm={12} xs={12}>
          <FormGroup>
            <Label>Status de Aprovação</Label>
            <Input
              type="select"
              value={statusAprovacao}
              onChange={(e) => {
                setPage(1);
                setStatusAprovacao(e.target.value);
              }}
            >
              <option value="">Todos</option>
              <option value="Aprovado">Aprovado</option>
              <option value="Não Aprovado">Não Aprovado</option>
              <option value="Análise">Análise</option>
            </Input>
          </FormGroup>
        </Col>
        <Col md={2} sm={12} xs={12}>
          <FormGroup>
            <Label>Buscar</Label>
            <Input
              type="search"
              value={search}
              placeholder="Nome, Apelido, Email ou Telefone"
              onChange={(e) => {
                setPage(1);
                setSearch(e.target.value);
              }}
            />
          </FormGroup>
        </Col>
        <Col md={4} sm={12} xs={12}>
          <div style={{ display: "flex", gap: 15 }}>
            {search && (
              <Button
                className="w-fit w-sm-auto"
                color="secondary"
                onClick={fetchDadosUsuarios}
                style={{ marginTop: 26 }}
              >
                <FiSearch size={22} />
              </Button>
            )}

            {userData?.tipoConta !== "automacao" && userData?.tipoConta !== "financeiro" &&
              <Button
                className="w-fit w-sm-auto"
                color="secondary"
                onClick={() => setModalAberto(true)}
                style={{ marginTop: 26 }}
              >
                <FaUserPlus size={22} />
              </Button>
            }

            {userData?.tipoConta !== "automacao" && userData?.tipoConta !== "financeiro" &&
              <Button
                className="w-fit w-sm-auto"
                color="success"
                onClick={() => setModalAbertoAfiliado(true)}
                style={{ marginTop: 26 }}
              >
                <FaUserPlus size={22} /> Novo Afiliado
              </Button>
            }

            {userData?.tipoConta !== "automacao" && userData?.tipoConta !== "financeiro" && (
              <Button
                className="w-fit w-sm-auto"
                color="primary"
                onClick={exportarUsuariosUtm}
                style={{ marginTop: 26 }}
              >
                Exportar UTM
              </Button>
            )}
          </div>
        </Col>
      </Row>

      <div style={{ marginTop: 15, marginBottom: 10, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <span
          style={{
            fontWeight: "bold",
            color: "#6d6d6d",
          }}
        >
          Total de usuários: {totalDocs}
        </span>

        <FormGroup switch>
          <Input
            type="switch"
            checked={filterIncompleteTerms}
            onChange={() => setFilterIncompleteTerms((prev) => !prev)}
          />
          <Label check style={{ marginTop: 5 }}>Termos Incompletos</Label>
        </FormGroup>
      </div>

      <Table striped responsive>
        <thead>
          <tr>
            <th
              style={{ cursor: "pointer" }}
              onClick={() => {
                setSortField("nome");
                setSortOrder(sortOrder === "asc" ? "desc" : "asc");
              }}
            >
              Nome{" "}
              {sortField === "nome" &&
                (sortOrder === "asc" ? <IoIosArrowDown /> : <IoIosArrowUp />)}
            </th>
            <th>Apelido</th>
            <th
              style={{ cursor: "pointer" }}
              onClick={() => {
                setSortField("email");
                setSortOrder(sortOrder === "asc" ? "desc" : "asc");
              }}
            >
              E-mail{" "}
              {sortField === "email" &&
                (sortOrder === "asc" ? <IoIosArrowDown /> : <IoIosArrowUp />)}
            </th>
            <th>Tipo </th>
            <th>Telefone</th>
            <th>CPF/CNPJ</th>
            <th>Cidade/Estado</th>
            <th>Status</th>
            <th>Docs</th>
            <th>Redes</th>
            <th>Ações</th>
          </tr>
        </thead>
        <tbody>
          {listaUsuarios.map((solicitacao, index) => (
            <tr key={index}>
              <td>{solicitacao.nome}</td>
              <td>{solicitacao.apelido ? solicitacao.apelido : "N/A"}</td>
              <td>{solicitacao.email}</td>
              <td style={{ textTransform: 'capitalize' }}>
                {solicitacao.tipoConta === "usuario"
                  ? "Cortador"
                  : solicitacao.tipoConta}
              </td>
              <td>{formatPhone(solicitacao.telefone)}</td>
              <td>{formatCpfCnpj(solicitacao.cpfCnpj)}</td>
              <td>{`${solicitacao.cidade}/${solicitacao.estado}`}</td>
              <td>{solicitacao.status}</td>
              <td>
                {userData?.tipoConta !== "automacao" ? (
                  <>
                    {solicitacao.documentoFrente ? (
                      <Button
                        color="primary"
                        outline
                        size="sm"
                        onClick={() => {
                          handleOpenDocs(
                            solicitacao.documentoFrente,
                            solicitacao.documentoVerso,
                            solicitacao.nome,
                            formatCpfCnpj(solicitacao.cpfCnpj)
                          );
                        }}
                        disabled={userData?.tipoConta === "financeiro"}
                      >
                        <FaFileAlt />
                      </Button>
                    ) : (
                      <Button color="danger" outline size="sm" disabled>
                        <BsFileEarmarkExcelFill />
                      </Button>
                    )}
                  </>
                ) : (
                  <FiLock size={22} />
                )}
              </td>
              <td>
                {userData?.tipoConta !== "automacao" ? (
                  <>
                    {solicitacao.redesSociais && solicitacao.redesSociais.length > 0 ? (
                      <Button
                        color="primary"
                        outline
                        size="sm"
                        onClick={() => handleAbrirModalRedes(solicitacao)}
                        disabled={userData?.tipoConta === "financeiro"}
                      >
                        <FaGlobe />
                      </Button>
                    ) : (
                      <Button 
                        onClick={() => handleAbrirModalRedes(solicitacao)} 
                        color="secondary" 
                        outline size="sm" 
                      >
                        <FaEyeSlash />
                      </Button>
                    )}
                  </>
                ) : (
                  <FiLock size={22} />
                )}
              </td>
              <td style={{ textAlign: 'center' }}>
                {userData?.tipoConta === "financeiro" ? (
                  <div>
                    <button
                      style={{ border: 'none', backgroundColor: 'transparent' }}
                      onClick={() => {
                        setUsuarioSelecionado(solicitacao);
                        setModalAberto(true);
                        setFinanceiroReadonly(true)
                      }}
                    >
                      <FaEye size={22} color="#0d6efd" />
                    </button>
                  </div>
                ) : (
                  <>
                    <Button
                      color="success"
                      block
                      className="me-1"
                      onClick={() => {
                        setUsuarioSelecionado(solicitacao);
                        solicitacao.tipoConta === "afiliado" ? setModalAbertoAfiliado(true) : setModalAberto(true);
                      }}
                      style={{ marginBottom: 5 }}
                    >
                      Editar
                    </Button>

                    {solicitacao.status === "ativo" ? (
                      <Button
                        color="danger"
                        block
                        onClick={() => {
                          setUidParaReprovar(solicitacao.uid);
                          setShowMotivoModal(true);
                        }}
                      >
                        Desativar
                      </Button>
                    ) : (
                      <Button
                        color="success"
                        block
                        onClick={() => activateUser(solicitacao.uid)}
                      >
                        Ativar
                      </Button>
                    )}
                  </>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </Table>

      <Pagination
        style={{
          display: "flex",
          justifyContent: "center",
          marginTop: 5,
        }}
      >
        <PaginationItem disabled={page === 1}>
          <PaginationLink previous onClick={() => setPage(page - 1)} />
        </PaginationItem>

        {Array.from({ length: totalPages }, (_, i) => (
          <PaginationItem active={page === i + 1} key={i}>
            <PaginationLink onClick={() => setPage(i + 1)}>
              {i + 1}
            </PaginationLink>
          </PaginationItem>
        ))}

        <PaginationItem disabled={page >= totalPages}>
          <PaginationLink next onClick={() => setPage(page + 1)} />
        </PaginationItem>
      </Pagination>

      <ModalNovoUsuario
        isOpen={modalAberto}
        onClose={() => {
          setModalAberto(false);
          fetchDadosUsuarios();
          setUsuarioSelecionado(null);
          setFinanceiroReadonly(false)
        }}
        isReadonly={financeiroReadonly}
        usuarioSelecionado={usuarioSelecionado}
      />

      <ModalNovoAfiliado
        isOpen={modalAbertoAfiliado}
        onClose={() => {
          setModalAbertoAfiliado(false);
          fetchDadosUsuarios();
          setUsuarioSelecionado(null);
          setFinanceiroReadonly(false)
        }}
        isReadonly={financeiroReadonly}
        usuarioSelecionado={usuarioSelecionado}
      />

      <ModalMotivos
        isOpen={showMotivoModal}
        toggle={() => setShowMotivoModal(false)}
        uid={uidParaReprovar}
        onConfirm={async (uid, motivo) => {
          await deactivateUser(uid, motivo);
        }}
      />

      <ModalDocumentos
        isOpen={showDocsModal}
        toggle={() => setShowDocsModal(false)}
        frente={docFrente}
        verso={docVerso}
        nome={nome}
        cpfCnpj={cpfCnpj}
      />

      <ModalListaDeRedes
        isOpen={modalRedesAberto}
        toggle={() => setModalRedesAberto(false)}
        redes={redesSelecionadas}
        onSave={handleSalvarRedes}
      />
    </div>
  );
}

export default Usuarios;